module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/HeartGirl-ad7451f20b4030ae202204ddf3716909.png";